<template>
    <div class="flex flex-col mt-5">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
            >
                <table class="min-w-full divide-y divide-gray-200">
                    <thead>
                        <tr>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.quantity') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.severity') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.type') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.internal_teacher_note') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.public_description') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                {{ $t('messages.punishment') }}
                            </th>
                            <th
                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                            >
                                <span class="sr-only">{{ $t('messages.actions') }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-white" v-for="(row, index) in items" :key="index">
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <FormInput
                                    required
                                    id="quantity"
                                    v-model="row.quantity"
                                    name="quantity"
                                    type="number"
                                    min="2"
                                    max="50"
                                    class="mt-1 w-20"
                                />
                                <FormError :value="errors[`rules.${index}.quantity`]" class="mt-2 max-w-sm" />
                            </td>
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <FormSelect
                                    required
                                    id="severity"
                                    v-model="row.severity"
                                    name="severity"
                                    class="mt-1"
                                    :options="options.severities"
                                />
                                <FormError :value="errors[`rules.${index}.severity`]" class="mt-2 max-w-sm" />
                            </td>
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <div>
                                    <label>
                                        <input
                                            name="homework"
                                            type="checkbox"
                                            v-model="row.homework"
                                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                        />
                                        {{ $t('messages.homework') }}
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input
                                            name="homework"
                                            type="checkbox"
                                            v-model="row.material"
                                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                        />
                                        {{ $t('messages.materials') }}
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <input
                                            name="homework"
                                            type="checkbox"
                                            v-model="row.behaviour"
                                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                        />
                                        {{ $t('messages.behaviour') }}
                                    </label>
                                </div>
                                <FormError :value="errors[`rules.${index}`]" class="mt-2 max-w-sm" />
                            </td>
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <FormTextarea
                                    id="description"
                                    v-model="row.internal_teacher_note"
                                    name="internal_teacher_note"
                                    type="text"
                                    class="mt-1"
                                />
                                <FormError
                                    :value="errors[`rules.${index}.internal_teacher_note`]"
                                    class="mt-2 max-w-sm"
                                />
                            </td>
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <FormTextarea
                                    id="description"
                                    v-model="row.public_description"
                                    name="public_description"
                                    type="text"
                                    class="mt-1 alert-background-icon"
                                />
                                <FormError :value="errors[`rules.${index}.public_description`]" class="mt-2 max-w-sm" />
                            </td>
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <FormTextarea
                                    id="description"
                                    v-model="row.punishment"
                                    name="punishment"
                                    type="text"
                                    class="mt-1"
                                />
                                <FormError :value="errors[`rules.${index}.punishment`]" class="mt-2 max-w-sm" />
                            </td>
                            <td
                                class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                            >
                                <button
                                    type="button"
                                    @click="deleteRow(index)"
                                    class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                        <path
                                            fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"
                                        ></path>
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-3">
                <button
                    type="button"
                    @click="addRow()"
                    class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    <svg
                        class="h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';

export default {
    emits: ['update:modelValue'],

    components: {
        FormError,
        FormInput,
        FormSelect,
        FormTextarea,
    },

    props: ['modelValue', 'options', 'defaults', 'errors'],
    name: 'FoulRulesFormTable',

    data() {
        return {
            items: this.modelValue,
        };
    },

    methods: {
        addRow() {
            this.items.push({
                severity: null,
                quantity: 3,
                //
                homework: false,
                material: false,
                behaviour: false,
                //
                public_description: null,
                internal_teacher_note: null,
                punishment: null,
            });
        },
        deleteRow(index) {
            this.items.splice(index, 1);
            if (this.items.length === 0) {
                this.addRow();
            }
        },
    },

    watch: {
        items(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },

    mounted() {
        if (this.items.length === 0) {
            this.addRow();
        }
    },
};
</script>
